(()=>{
  if(customElements.get('shipping-progress'))return;
  let current,request=0,timer;
  const money=new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP',minimumFractionDigits:2,maximumFractionDigits:2});
  const renderAll=()=>document.querySelectorAll('shipping-progress').forEach(el=>el.render?.());
  customElements.define('shipping-progress',class extends HTMLElement{
    connectedCallback(){
      current={total_price:Number(this.dataset.total),item_count:Number(this.dataset.count),requires_shipping:this.dataset.shippable==='true'};
      renderAll();
    }
    render(){
      if(!current)return;
      this.hidden=current.item_count>0&&!current.requires_shipping;
      const target=Number(this.dataset.target),remaining=Math.max(0,target-current.total_price),percentage=Math.min(100,Math.max(0,current.total_price/target*100));
      this.classList.toggle('is-complete',remaining===0);
      const message=this.querySelector('[data-shipping-message]');
      message.replaceChildren();
      const strong=document.createElement('strong');
      if(remaining){strong.textContent=money.format(remaining/100).replace(/\.00$/,'');message.append(strong,' to free mainland UK delivery');}
      else{strong.textContent='Free mainland UK delivery unlocked';message.append(strong);}
      const track=this.querySelector('[role="progressbar"]');track.setAttribute('aria-valuenow',String(Math.round(percentage)));track.firstElementChild.style.width=percentage+'%';
    }
  });
  const refresh=()=>{clearTimeout(timer);timer=setTimeout(async()=>{const id=++request;try{const r=await fetch((window.Shopify?.routes?.root||'/')+'cart.js',{credentials:'same-origin',cache:'no-store'});if(!r.ok)return;const cart=await r.json();if(id!==request)return;current=cart;renderAll();}catch{}},120);};
  document.addEventListener('product:added',refresh);document.addEventListener('cart:refresh',refresh);document.addEventListener('cart:updated',refresh);
  window.addEventListener('pageshow',refresh);
})();


